<template>
  <div class="input-wrapper">
    <input
      v-model="text"
      type="text"
      class="reset-input"
      :class="{ 'focused': isFocused }"
      :placeholder="placeholder"
      @focus="isFocused = true"
      @blur="onBlur"
    />
  </div>
</template>

<script>
export default {
  props: {
    // Vue 3 style (primary)
    modelValue: {
      type: String,
      default: undefined,
    },
    // Vue 2 style (fallback for backward compatibility)
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Click to edit',
    },
  },
  emits: ['update:modelValue', 'input'],
  data() {
    return {
      text: '',
      isFocused: false,
    };
  },
  computed: {
    currentValue() {
      // Prefer modelValue (Vue 3) over value (Vue 2)
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
  },
  watch: {
    currentValue: {
      immediate: true,
      handler(newValue) {
        this.text = newValue;
      },
    },
  },
  methods: {
    onBlur() {
      this.isFocused = false;
      // Emit both for backward compatibility
      this.$emit('update:modelValue', this.text);
      this.$emit('input', this.text);
    },
  },
};
</script>

<style scoped>
.reset-input {
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  box-shadow: none;
  appearance: none;
  font: inherit;
  color: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  text-transform: inherit;
  line-height: inherit;
  word-spacing: inherit;
  direction: inherit;
  resize: none;
  text-align: right;
  cursor: pointer;
}

.focused {
  padding: 0 0.5rem;
  border: 2px solid var(--primary-bg);
  border-radius: 0.25rem;
}
</style>
